// Module
var code = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M5 9H12V5.48284C12 5.30466 12.2154 5.21543 12.3414 5.34142L19 12L12.3414 18.6586C12.2154 18.7846 12 18.6953 12 18.5172V15H5\" stroke=\"none\" stroke-width=\"2\"/> </svg> ";
// Exports
module.exports = code;